
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/refurbished",
      function () {
        return require("private-next-pages/refurbished/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/refurbished"])
      });
    }
  